import scribe from '@grab-x/scribe-web-sdk';
import { changeCampaignStatus, getApprovalFlowConfig, getCampaignBudgetSources, getCampaignTargetVerticals, getFeatureFlagConfig, getListRuleTypes } from 'actions/newTridentExtra';
import { cpListProducts } from 'actions/ucd';
import formComponent from 'components/decorators/form_component';
import { OverviewForm } from 'components/form/trident-campaigns';
import {
  getContentPortalProductOfferingOptions,
  getNextTargetVerticalCVP,
  isContentPortalProductsEnabled,
} from 'components/form/trident-campaigns/content-portal-product-offerings';
import { campaignStatus, trackableCommsActions } from 'data/trident-campaigns';
import { campaignChangeTypes, nodeTypes, ownerTypes, startingNodeTypes } from 'data/trident-types';
import _ from 'lodash';
import moment from 'moment';
import { INITIAL_NODE } from 'omega-rtc/utils/trident-node-utils';
import {
  isTaiwanCampaignCreationAllowed,
  TAIWAN_CAMPAIGN_CREATION_RESTRICTED_MESSAGE,
} from 'omega-rtc/utils/taiwan-campaign-operation';
import { parseUCDSyncErrMsg } from 'omega-rtc/utils/ucd-utils';
import { JOURNEY_CAMPAIGN_TYPE } from 'omega-rtc/views/trident-campaigns/common/util';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import type { StoreState } from 'reducers';
import type { UserState } from 'reducers/user';
import { Button, Container, Feed, Grid, Icon, Label, Message, Modal, Popup, Segment } from 'semantic-grab-ui/src';
import type { Country } from 'types/country';
import type { RequestStates } from 'types/redux';
import type { TridentCampaignDetails } from 'types/trident-campaigns';
import { hasJustSuccess } from 'utils/request-state-utils';
import Toastr from 'utils/toastr-util';
import { hasPermission, hasTridentPermission } from 'utils/user-utils';
import TridentCampaignBuilder from 'views/trident-campaigns/common/TridentCampaignBuilder';
import NodePreview from 'views/trident-campaigns/show/NodePreview';
import 'views/trident-campaigns/TridentCampaigns.scss';
import ScribeEventName from '../../../constants/scribe';
import { processCampaignData } from '../../../utils/scribe';
import { STATUS_ACTIVE } from '../../ucd/content-config/adapters';
import './TridentCampaignForm.scss';
import CampaignParquetPreviewModal from 'components/form/trident-campaigns/CampaignParquetPreviewModal';
import { findCampaignParquetPreviewSources } from 'components/form/trident-campaigns/parquet-user-attributes-preview-utils';
import VersionHistoryList from './VersionHistoryList';

const EMPTY_ARRAY: any[] = [];

interface Props {
  setRef: (ref: any) => void;
  user: UserState;
  changeCampaignStatus: (actionData: any, countryID: number, campaignID: string) => void;
  changeCampaignStatusRequest: RequestStates;
  model: TridentCampaignDetails;
  canActivate: boolean;
  onModelChange: (_?: TridentCampaignDetails) => void;
  userPermissions: object;
  isValid: () => boolean;
  error: any;
  enableQuest: boolean;
  listRuleTypes: object;
  campaignObjectives: any[];
  featureFlagConfig: object;
  getListRuleTypes: (params: any) => void;
  getCampaignBudgetSources: () => void;
  getCampaignTargetVerticals: () => void;
  getFeatureFlagConfig: () => void;
  cpListProducts: (countryCode: string, status: string) => void;
  cpProductsByCountry: object;
  countries: Country[];
}

interface State {
  renderNodePreview: boolean;
  listOfParentNodesKey: string[];
  currentClickedNode: string;
  clickedScenarioIndex: number;
  status: string;
  statusRequestType: string;
  showModal: { [key: string]: boolean };
  scenarioIndex: number;
  nodeType: string;
  maxValueOfNodesKeyFromApi: number;
  treatmentStartKeysList: string[];
  maxNodeKeyValue: number;
  currentNode: string;
  parentKeyList: string[];
  parentNode: string;
  autoShowHistorySearch: object | null;
  showParquetPreviewModal: boolean;
  country?: Country;
}

export const resolveEffectiveCountry = ({
  stateCountry,
  countries = [],
  countryID,
}: {
  stateCountry?: Country;
  countries?: Country[];
  countryID?: number;
}): Country | undefined => {
  if (stateCountry) {
    return stateCountry;
  }

  return _.find(countries, ['countryID', countryID]);
};

@formComponent({})
export class TridentCampaignForm extends Component<Props, State> {
  requestedContentPortalProductCountryCodes: { [countryCode: string]: boolean } = {};

  constructor(props: Props) {
    super(props);
    // using state to store info to add node preview functionality.
    this.state = {
      renderNodePreview: false,
      listOfParentNodesKey: [],
      currentClickedNode: '',
      clickedScenarioIndex: -1,
      status: _.get(this.props.model, 'status'),
      statusRequestType: '',
      showModal: {},
      scenarioIndex: 0,
      nodeType: '',
      maxValueOfNodesKeyFromApi: _.get(this.props.model, 'maxValueOfNodesKeyFromApi', 0),
      treatmentStartKeysList: this.getTreamentStartKeysList(this.props.model.nodes),
      maxNodeKeyValue: this.getMaxNodeKeyValue(this.props.model.nodes),
      currentNode: '',
      parentKeyList: [],
      parentNode: '',
      autoShowHistorySearch: null,
      showParquetPreviewModal: false,
    };
    if (this.props.setRef) {
      this.props.setRef(this);
    }
  }

  isValid = () => {
    if (
      !this.isEdit()
      && !isTaiwanCampaignCreationAllowed(
        _.get(this.props.model, 'countryID'),
        this.props.user.email,
      )
    ) {
      return false;
    }

    return this.props.isValid();
  };

  getTreamentStartKeysList = (nodes: object) => {
    const nodeKeys = _.keysIn(nodes);
    const treatmentStartKeysList = [];
    nodeKeys.forEach(nodeKey => {
      if (startingNodeTypes.includes(nodes[nodeKey].type)) {
        treatmentStartKeysList.push(nodeKey);
      }
    });
    return treatmentStartKeysList;
  }

  getMaxNodeKeyValue = (nodes: object) => {
    const nodeKeys = _.keysIn(nodes);
    return nodeKeys.reduce((maxInt, val) => {
      const valInt = parseInt(val, 10);
      maxInt = valInt > maxInt ? valInt : maxInt;
      return maxInt;
    }, 0);
  }

  UNSAFE_componentWillMount() {
    const updatedModel = _.cloneDeep(this.props.model);
    _.set(updatedModel, 'adminEmail', this.props.user.email);
    this.props.onModelChange(updatedModel);
  }

  componentDidMount() {
    const owner = _.get(this.props.model, 'owner', '');
    const targetUserType = _.get(this.props.model, 'targetUserType', '');
    this.props.getListRuleTypes({ owner, targetUserType });
    this.props.getApprovalFlowConfig();
    this.props.getCampaignBudgetSources();
    this.props.getCampaignTargetVerticals();
    this.props.getFeatureFlagConfig();

    // Check URL for history modal auto-open
    this.checkUrlForHistoryModal();
    this.checkUrlForParquetPreviewModal();
    this.loadContentPortalProductsForEffectiveCountry();
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.state.country !== prevState.country) {
      return;
    }

    const previousCountryCode = _.get(this.getEffectiveCountry(prevProps, prevState), 'code', '');
    const countryCode = _.get(this.getEffectiveCountry(), 'code', '');

    if (countryCode && countryCode !== previousCountryCode) {
      this.loadContentPortalProductsForEffectiveCountry();
    }
  }

  checkUrlForHistoryModal = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const filterParam = urlParams.get('f');

    if (filterParam === 'history-search') {
      // Extract URL parameters for pre-filling the form
      const accountID = urlParams.get('accountid') || '';
      const start = urlParams.get('start') || '';
      const end = urlParams.get('end') || '';

      // Find the first node that supports history (actions, count, or scenarios)
      const supportedNodeTypes = [nodeTypes.actions, nodeTypes.count, nodeTypes.scenarios];
      const nodes = _.get(this.props.model, 'nodes', {});
      const targetNode = _.find(nodes, (node) => {
        return supportedNodeTypes.includes(node.type);
      });

      if (targetNode) {
        const nodeId = _.findKey(nodes, node => node === targetNode);
        // Auto-open NodePreview with the target node and history search parameters
        this.setState({
          renderNodePreview: true,
          listOfParentNodesKey: [nodeId],
          currentClickedNode: nodeId,
          clickedScenarioIndex: -1,
          autoShowHistorySearch: {
            accountID,
            timeRangeStart: start,
            timeRangeEnd: end,
          },
        });
      }
    }
  }

  checkUrlForParquetPreviewModal = () => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('f') === 'parquet-preview') {
      this.setState({
        showParquetPreviewModal: true,
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (hasJustSuccess(this.props.changeCampaignStatusRequest, nextProps.changeCampaignStatusRequest)) {
      if (nextProps.ucdErrMessage) {
        const reason = parseUCDSyncErrMsg(nextProps.ucdErrMessage);
        Toastr.error(`Trident Campaign ${this.state.statusRequestType} successfully, but failed to update in Holos : ${reason}`);
      } else {
        Toastr.success(`Trident campaign ${this.state.statusRequestType} successfully.`);
      }
      const updatedModel = _.cloneDeep(this.props.model);
      _.set(updatedModel, 'status', this.state.statusRequestType);
      this.props.onModelChange(updatedModel);
      this.setState({ status: this.state.statusRequestType });
    }

    this.setState({
      treatmentStartKeysList: this.getTreamentStartKeysList(nextProps.model.nodes),
      maxNodeKeyValue: this.getMaxNodeKeyValue(nextProps.model.nodes),
    });
  }


  dateAndTimeValid = () => {
    let valid = true;
    const nodes = _.get(this.props, 'model.nodes', {});
    let hasEmptyNextTimeTrigger = false;
    _.map(nodes, (node) => {
      if (node.type === 'time') {
        const nextTriggerTime = _.get(node, 'data.nextTriggerTime', '');
        if (_.isEmpty(nextTriggerTime)) {
          hasEmptyNextTimeTrigger = true;
          valid = false;
          return;
        }
        const treatmentDate = new Date(nextTriggerTime.format());
        const treatmentStartTime = treatmentDate.getTime();
        const currentDate = new Date();
        const currentTime = currentDate.getTime();
        if (currentTime >= treatmentStartTime) valid = false; // time of treatments must be ahead of current time
      }
    });
    if (hasEmptyNextTimeTrigger) Toastr.info('Some treatments contain empty next trigger time. HINT: Save compaign before activating.');
    return valid;
  }

  handleChangeStatus = (event: any, data: any) => {
    const status = data.name;
    const { model, user, approvalFlowConfig } = this.props;
    const allowSelfApprove = _.get(approvalFlowConfig, 'allowSelfApprove', true);

    // for SOX compliance, we don't allow user to deactivate a campaign that they have created or updated before
    if (status === campaignStatus.inactive && !allowSelfApprove) {
      const records = _.get(model, 'editRecords', []);
      for (let i = 0; i < records.length; i += 1) {
        if (records[i].editor === user.email && _.includes([campaignChangeTypes.create, campaignChangeTypes.update], records[i].changeType)) {
          Toastr.error('You are not allowed to deactivate a campaign that you have edited');
          return;
        }
      }
    }

    // eslint-disable-next-line no-alert
    const confirmValue = confirm(`Are you sure to ${status} campaign?`);
    if (!confirmValue) return;
    this.setState({ statusRequestType: status });
    const statusValue = status === campaignStatus.active ? 1 : 2;
    const countryID = parseInt(_.get(model, 'countryID'), 10);
    const campaignID = _.get(model, 'campaignID');
    const actionData = { status: statusValue, adminEmail: user.email };
    this.props.changeCampaignStatus(actionData, countryID, campaignID);

    scribe.sendEvent(
      status === campaignStatus.active
        ? ScribeEventName.CAMPAIGN_ACTIVATED
        : ScribeEventName.CAMPAIGN_DEACTIVATED,
      processCampaignData(
        { ...model, user }
      ),
    );
  };

  isEdit = (): boolean => {
    return !_.isEmpty(_.get(this.props.model, 'campaignID'));
  };

  getEffectiveCountry = (props: Props = this.props, state: State = this.state): Country | undefined => {
    return resolveEffectiveCountry({
      stateCountry: state.country,
      countries: props.countries,
      countryID: _.get(props.model, 'countryID'),
    });
  };

  handleOnModelChange = (newModel: TridentCampaignDetails) => {
    // check whether owner or target user type changed
    // if either one is changed, and both have value, we will reload rule types
    const newOwner = _.get(newModel, 'owner', '');
    const newUserType = _.get(newModel, 'targetUserType', '');
    const oldOwner = _.get(this.props.model, 'owner', '');
    const oldUserType = _.get(this.props.model, 'targetUserType', '');
    this.props.onModelChange(newModel);
    if ((newOwner !== oldOwner || newUserType !== oldUserType) && (!_.isEmpty(newOwner) && !_.isEmpty(newUserType))) {
      this.props.getListRuleTypes({ owner: newOwner, targetUserType: newUserType });
    }
  };

  getContentPortalProductsForCountry = (countryCode: string) => {
    return _.get(this.props.cpProductsByCountry, [countryCode, 'active'], EMPTY_ARRAY);
  };

  hasContentPortalProductsLoaded = (countryCode: string) => {
    return Boolean(countryCode && _.has(this.props.cpProductsByCountry, [countryCode, 'active']));
  };

  loadContentPortalProducts = (country: Country) => {
    const countryCode = _.get(country, 'code', '');
    if (
      !isContentPortalProductsEnabled() ||
      !countryCode ||
      this.hasContentPortalProductsLoaded(countryCode) ||
      this.requestedContentPortalProductCountryCodes[countryCode]
    ) {
      return;
    }

    this.requestedContentPortalProductCountryCodes[countryCode] = true;
    this.props.cpListProducts(countryCode, STATUS_ACTIVE);
  };

  loadContentPortalProductsForEffectiveCountry = () => {
    const country = this.getEffectiveCountry();
    if (country) {
      this.loadContentPortalProducts(country);
    }
  };

  getTargetVerticalCVPForCountry = (campaign: TridentCampaignDetails, country: Country) => {
    const countryCode = _.get(country, 'code', '');
    const selectedVertical = _.get(campaign, 'targetVertical', '');
    const options = getContentPortalProductOfferingOptions({
      products: this.getContentPortalProductsForCountry(countryCode),
      vertical: selectedVertical,
    });

    return getNextTargetVerticalCVP({
      currentValue: '',
      hasLoadedProducts: this.hasContentPortalProductsLoaded(countryCode),
      options,
      selectedVertical,
    });
  };

  handleOnCountryChange = (country: Country) => {
    this.setState({ country });
    this.loadContentPortalProducts(country);
    const { model } = this.props;
    if (country.countryID === model.countryID) {
      return;
    }
    const campaign = _.cloneDeep(model);
    campaign.countryID = country.countryID;
    campaign.timezone = '';
    campaign.timezoneName = '';
    if (isContentPortalProductsEnabled()) {
      _.set(campaign, 'targetVerticalCVP', this.getTargetVerticalCVPForCountry(campaign, country));
    }

    // update scenario's currency
    _.map(this.props.model.nodes, (node, nodeIndex) => {
      if (node.type === nodeTypes.scenarios) {
        _.get(node, 'data.scenarios', []).forEach((scenario, scenarioIndex) => {
          if (!_.isEmpty(_.get(scenario, 'currency'))) {
            _.set(campaign, `nodes[${nodeIndex}].data.scenarios[${scenarioIndex}].currency`, country.currency);
          }
        });
      }
    });

    this.handleOnModelChange(campaign);
  };

  // set list of ancestors of current clicked node and render node preview.
  handleNodePreview = (listOfParentNodesKey: string[], currentClickedNode: string, clickedScenarioIndex: number = -1) => {
    this.setState(
      {
        renderNodePreview: true,
        listOfParentNodesKey,
        currentClickedNode,
        clickedScenarioIndex,
      }
    );
  };
  // code to close node preview.
  closeNodePreview = () => {
    this.setState(
      {
        currentClickedNode: 0,
        listOfParentNodesKey: [],
        renderNodePreview: false,
      }
    );
  };

  openModal = (nodeType, scenarioIndex, type) => {
    this.setState({
      showModal: { [type]: true },
      nodeType,
      scenarioIndex,
    });
  }

  closeModal = () => {
    this.setState({
      showModal: {},
    });
  }

  openParquetPreviewModal = () => {
    this.setState({
      showParquetPreviewModal: true,
    });
  }

  closeParquetPreviewModal = () => {
    this.setState({
      showParquetPreviewModal: false,
    });
  }

  clearAutoShowHistorySearch = () => {
    this.setState({
      autoShowHistorySearch: null,
    });
  }

  // if any time max key of nodes available in current model goes below to key store in state then initialise 'nodeKeyMaxVal' with key store in state.
  // this case will happen when performing deletion. So this check is a prevention.
  recheckingNodeKeyMaxVal = (maxNodeKeyValue: number) => {
    if (maxNodeKeyValue < parseInt(this.state.maxValueOfNodesKeyFromApi, 10)) {
      maxNodeKeyValue = parseInt(this.state.maxValueOfNodesKeyFromApi, 10);
    }
    return maxNodeKeyValue;
  }

  // duplicateBranch clones the branch starting with the specified node
  duplicateBranch = (nodeKey: string) => {
    const updatedModel = _.cloneDeep(this.props.model);
    const { nodes } = updatedModel;
    const cloned = {};

    // clone nodes
    let maxNodeKeyValue = this.recheckingNodeKeyMaxVal(this.state.maxNodeKeyValue);
    maxNodeKeyValue += 1;
    const clonedRootNodeID = this.dfsClone(nodes[nodeKey], nodes, cloned, `${maxNodeKeyValue}`);
    _.set(updatedModel, 'nodes', {
      ...updatedModel.nodes,
      ...cloned,
    });

    // update global state variables: nodesOccMap, currentNode
    const nodesOccMap = _.get(updatedModel, 'nodesOccMap');
    _.map(cloned, (node, id) => {
      const dynamicNodeName = { nodeID: id, key: (nodesOccMap[node.type].length) + 1 };
      nodesOccMap[node.type].push(dynamicNodeName);
    });
    _.set(updatedModel, 'nodesOccMap', nodesOccMap);
    this.setState({
      currentNode: clonedRootNodeID,
      parentNode: '-1',
    });
    if (nodes[nodeKey].type === nodeTypes.scenarios) {
      this.setState({
        scenarioIndex: 0,
      });
    }

    // update model
    this.props.onModelChange(updatedModel);

    Toastr.success(`${nodes[nodeKey].type} branch duplicated! Scroll to the bottom of the page to see it!`);
  };

  // dfsClone clones node branch recursively, saves cloned nodes to `cloned`, and returns the node ID of the root cloned node
  dfsClone = (node: object, oriNodes: object, cloned: object, startingID: string) => {
    // clone the current node
    const curMaxID = _.maxBy(_.keys(cloned), (val) => { return Number(val); });
    const curID = _.isEmpty(cloned) ? startingID : `${Number(curMaxID) + 1}`;
    cloned[curID] = _.cloneDeep(node);
    if (node.type === nodeTypes.schedule || node.type === nodeTypes.time) {
      _.unset(cloned[curID], 'data.nextTriggerTime');
      _.unset(cloned[curID], 'data.lastHappenedAt');
    }

    // clone child nodes recursively
    const clonedChildIDs = [];
    _.map(node.children, (childID) => {
      const clonedChildID = this.dfsClone(oriNodes[childID], oriNodes, cloned, startingID);
      clonedChildIDs.push(clonedChildID);
    });
    cloned[curID].children = clonedChildIDs;

    return curID;
  };

  // this addNode function will be called to add different nodes. Passing maximum key available in current model as parameter. This is to ensure that new node's key should be
  // in ascending order and passing type of node and parent key information. If node is either scenario or time, parent key value will be '-1' by default.
  addNode = (nodeType: string, parentKey: string = '-1', parentKeyList: string[] = [], defaultData: object, remainInModal: boolean, nodeKVMap: object) => {
    const updatedModel = _.cloneDeep(this.props.model);

    // create new node
    let maxNodeKeyValue = this.recheckingNodeKeyMaxVal(this.state.maxNodeKeyValue);
    maxNodeKeyValue += 1;
    const newNodeID = maxNodeKeyValue.toString();
    const newNode = _.cloneDeep(INITIAL_NODE[nodeType]);
    if (defaultData) {
      newNode.data = defaultData;
    }

    if (nodeKVMap) {
      for (const [key, value] of Object.entries(nodeKVMap)) {
        newNode[key] = value;
      }
    }

    _.set(updatedModel.nodes, newNodeID, newNode);

    // add the new node to the parent node's children list
    if (parentKey !== '-1') {
      const childrenList = _.get(updatedModel.nodes[parentKey], 'children', []);
      childrenList.push(newNodeID);
      _.set(updatedModel.nodes[parentKey], 'children', childrenList);
    }

    // add the new node to the occurrence map
    const nodesOccMap = _.get(updatedModel, 'nodesOccMap');
    this.addNodeToOccMap(nodesOccMap, newNodeID, nodeType);
    _.set(updatedModel, 'nodesOccMap', nodesOccMap);

    // update campaign
    this.props.onModelChange(updatedModel);

    // update state
    parentKeyList.push(newNodeID);
    this.setState({
      parentNode: parentKey,
      parentKeyList,
    });
    if ((nodeType !== nodeTypes.experimentTreatment) && !remainInModal) {
      this.setState({
        currentNode: newNodeID,
        showModal: {
          builder: true,
        },
        nodeType,
      });
    }
  };

  addNodeToOccMap = (nodesOccMap: object, nodeID: string, nodeType: string) => {
    nodesOccMap[nodeType].push({
      nodeID,
      key: (nodesOccMap[nodeType].length) + 1,
    });
  };

  // addDefaultHoldback adds an experiment node after the specified node, along with two experiemnt treatment nodes after the experiment node
  // one is control group for 10% holdback, the rest 90% is treatment group
  // it directly modifies the input model, without returning any value
  addDefaultExperiment = (nodeID: string) => {
    const model = _.cloneDeep(this.props.model);

    const maxNodeID = this.recheckingNodeKeyMaxVal(this.state.maxNodeKeyValue);
    const expNodeID = String(maxNodeID + 1);
    const expControlNodeID = String(maxNodeID + 2);
    const expTreatmentNodeID = String(maxNodeID + 3);
    const nodesOccMap = _.get(model, 'nodesOccMap', {});

    _.set(model.nodes, expNodeID, {
      type: nodeTypes.experiment,
      data: {
        groupPercentage: [90],
      },
      children: [expControlNodeID, expTreatmentNodeID],
    });
    this.addNodeToOccMap(nodesOccMap, expNodeID, nodeTypes.experiment);

    _.set(model.nodes, expControlNodeID, {
      type: nodeTypes.experimentTreatment,
      data: {
        groupID: 0,
      },
    });
    this.addNodeToOccMap(nodesOccMap, expControlNodeID, nodeTypes.experimentTreatment);

    _.set(model.nodes, expTreatmentNodeID, {
      type: nodeTypes.experimentTreatment,
      data: {
        groupID: 1,
      },
    });
    this.addNodeToOccMap(nodesOccMap, expTreatmentNodeID, nodeTypes.experimentTreatment);

    const childrenList = _.get(model.nodes[nodeID], 'children', []);
    childrenList.push(expNodeID);
    _.set(model.nodes[nodeID], 'children', childrenList);
    _.set(model, 'nodesOccMap', nodesOccMap);

    this.props.onModelChange(model);
  };

  // code to delete node
  // passing parent key and key of node to be deleted as parameter and if chain scenario then scenario index as well.
  deleteNode = (parentKey: string, currentNodeKey: string) => {
    const updatedModel = _.cloneDeep(this.props.model);

    // remove key of node to be deleted from children array of parent node.
    if (parentKey !== '-1') {
      const childrenList = updatedModel.nodes[parentKey].children || [];
      const filteredChildrenList = childrenList.filter(item => item !== currentNodeKey);
      if (filteredChildrenList.length === 0) {
        delete updatedModel.nodes[parentKey].children;
      } else {
        _.set(updatedModel.nodes[parentKey], 'children', filteredChildrenList);
      }
    }
    // remove node and its children from nodes object.
    this.deleteNodeRecursively(updatedModel, [currentNodeKey]);

    const filteredParentList = this.state.listOfParentNodesKey.filter(item => item !== currentNodeKey);
    // close node preview if all nodes have been deleted.
    if (filteredParentList.length === 0) {
      this.closeNodePreview();
    }
    this.setState({
      listOfParentNodesKey: filteredParentList,
      currentClickedNode: 0,
      renderNodePreview: false,
    });
    // update model
    this.props.onModelChange(updatedModel);
  };

  deleteNodeRecursively = (model: TridentCampaignDetails, nodeKeys: string[]) => {
    nodeKeys.forEach(nodeKey => {
      if (model.nodes[nodeKey].children) {
        this.deleteNodeRecursively(model, model.nodes[nodeKey].children);
      }
      delete model.nodes[nodeKey];
    });
  };

  containsTrackableComms = (model: TridentCampaignDetails) => {
    return _.some(model.nodes, node => {
      if (node.type !== nodeTypes.actions) {
        return false;
      }
      return _.some(node.data, action => _.includes(trackableCommsActions, _.get(action, 'type')));
    });
  };

  getMetricsUnavailableReason = () => {
    const { model } = this.props;
    // check this campaign has never been activated
    const hasBeenActivated = _.some(
      _.get(model, 'editRecords', []),
      x => x.changeType === campaignChangeTypes.activate,
    );

    if (!hasBeenActivated) {
      return 'No metrics available as the campaign has never been activated';
    }
    if (moment().diff(model.startTime, 'days') < 3) {
      return 'Metrics will only be available 3 days after the campaign starts';
    }
    if (model.startTime <= moment('20210101', 'YYYYMMDD')) {
      return 'Metrics are not available for campaigns that started before Jan 1st 2021';
    }
    if (!this.containsTrackableComms(model)) {
      return 'There are no trackable messaging actions in the campaign';
    }
    return '';
  };

  render() {
    const { model, canActivate, error = {}, userPermissions, listRuleTypes, appConfig = {}, webPath = '', featureFlagConfig } = this.props;
    const country = this.getEffectiveCountry();
    const cities = _.get(country, 'cities');
    const countryCode = _.get(country, 'code', '');

    const campaignID = model.campaignID || '';
    const countryID = model.countryID || 0;

    const updatedAt = _.get(model, 'updatedAtPretty', '');
    const updatedBy = _.get(model, 'updatedBy', '');
    const campaignType = _.get(model, 'campaignType', '');
    const isEditPage = this.isEdit();
    const isTaiwanCreationAllowed = isEditPage || isTaiwanCampaignCreationAllowed(
      countryID,
      this.props.user.email,
    );

    const isJourneyCampaign = campaignType === JOURNEY_CAMPAIGN_TYPE;
    const hasOverviewFieldsError = _.keysIn(error).some(errorName => errorName !== 'nodes');
    const canActivateField = canActivate || hasTridentPermission(userPermissions, _.get(model, 'targetUserType'), _.get(model, 'owner'), 'active');
    const hasParquetPreviewSources = !_.isEmpty(findCampaignParquetPreviewSources(model));

    const allowedOwners = [ownerTypes.targeting];
    if (this.props.enableQuest) {
      allowedOwners.push(ownerTypes.quest);
    }

    let versionHistoryView = null;
    const editRecords = _.get(model, 'editRecords', []).reverse(); // reverse records so that it's listed in reverse chronological order
    if (!_.isEmpty(editRecords)) {
      versionHistoryView = (
        <Modal trigger={<button className="view-history-button">View version history</button>} closeIcon size="mini">
          <Modal.Content>
            <VersionHistoryList
              records={editRecords}
              campaignID={campaignID}
              auditLogHost={_.get(featureFlagConfig, 'auditLogUrl', '')}
              auditLogIndex={_.get(featureFlagConfig, 'auditLogIndex', '')}
            />
          </Modal.Content>
        </Modal>
      );
    }

    return (
      <Container fluid>
        {!isTaiwanCreationAllowed && (
          <Message negative content={TAIWAN_CAMPAIGN_CREATION_RESTRICTED_MESSAGE} />
        )}
        {isJourneyCampaign && <h1>Journey campaign edit not supported. Please use Holos</h1>}
        <div>
          <Grid columns="equal">
            {isEditPage && updatedBy &&
              <Grid.Column textAlign="left">
                <Feed>
                  <Feed.Event>
                    <Feed.Label>
                      <Icon name="pencil alternate" />
                    </Feed.Label>
                    <Feed.Content>
                      <Feed.Date>{updatedAt}</Feed.Date>
                      <Feed.Summary>
                        Campaign is last updated by <span className="userInfo">{updatedBy}</span>
                        {versionHistoryView}
                      </Feed.Summary>
                    </Feed.Content>
                  </Feed.Event>
                </Feed>
              </Grid.Column>
            }
            {isEditPage &&
              <Grid.Column textAlign="right">
                {
                  _.get(appConfig, 'tridentMetricsPageEnabled', false) && <React.Fragment>
                    {
                      _.isEmpty(this.getMetricsUnavailableReason()) ?
                        <Button primary as={Link} to={`${webPath}/${countryID}/${campaignID}/metrics`} target="_blank">
                          View Performance
                        </Button>
                        :
                        <Popup content={this.getMetricsUnavailableReason()} trigger={<div style={{ display: 'inline' }}><Button disabled>View Performance</Button></div>} />
                    }
                  </React.Fragment>

                }
                <Button color="twitter" as={Link} to={`${webPath}/${countryID}/${campaignID}/review`}>
                  <Icon name="check" /> Review
                </Button>
                {
                  canActivateField &&
                  <React.Fragment>
                    {
                      !_.get(appConfig, 'tridentHideActivateButton', true) &&
                      <Button
                        name="ACTIVE"
                        positive
                        onClick={this.handleChangeStatus}
                        disabled={this.state.status === campaignStatus.active}
                      >
                        Activate
                      </Button>
                    }
                    <Button
                      name="INACTIVE"
                      negative
                      onClick={this.handleChangeStatus}
                      disabled={this.state.status !== campaignStatus.active}
                    >
                      Deactivate
                    </Button>
                  </React.Fragment>
                }

              </Grid.Column>
            }
          </Grid>
          {hasOverviewFieldsError &&
            <div id={'formErrMsg'}>
              <Message negative>
                {
                  _.map(Object.keys(error), err => {
                    if (err !== 'nodes') {
                      return (<Message.Header style={{ marginTop: '10px' }}>
                        <span className="validation-icon" />
                        {_.get(error, err)[0]}
                      </Message.Header>);
                    }
                  }
                  )
                }
              </Message>
            </div>
          }
          <Segment className="padding-lg">
            <OverviewForm
              onModelChange={this.handleOnModelChange}
              model={model}
              country={country}
              canActivate={canActivateField}
              handleOnCountryChange={this.handleOnCountryChange}
              allowedOwners={allowedOwners}
              userPermissions={userPermissions}
              campaignObjectives={this.props.campaignObjectives}
              campaignBudgetSources={this.props.budgetSources}
              campaignTargetVerticals={this.props.targetVerticals}
              featureFlagConfig={this.props.featureFlagConfig}
              contentPortalProducts={this.getContentPortalProductsForCountry(countryCode)}
              hasContentPortalProductsLoaded={this.hasContentPortalProductsLoaded(countryCode)}
            />
          </Segment>
          {!_.isEmpty(_.get(error, 'nodes', [])) &&
            <div id={'nodeErrMsg'}>
              <Message negative>
                <Message.Header>
                  <span className="validation-icon" />
                  {error.nodes[0]}
                </Message.Header>
              </Message>
            </div>
          }
          <div className={`${isJourneyCampaign ? 'disabled' : ''}`}>
            <Segment className="padding-lg">
              <Grid>
                <Grid.Column width={4}>
                  <Label
                    size="large"
                    color="teal"
                  >
                    <Icon name="sitemap" /> Campaign Builder
                  </Label>
                </Grid.Column>
                {campaignID &&
                  <Grid.Column width={12}>
                    <Button primary floated="right" as={Link} to={`${webPath}/${countryID}/${campaignID}/view`}>
                      View Summary
                    </Button>
                    {hasParquetPreviewSources &&
                      <Button color="blue" floated="right" onClick={this.openParquetPreviewModal}>
                        <Icon name="send" /> User Attribute Message Preview
                      </Button>
                    }
                    {hasParquetPreviewSources &&
                      <CampaignParquetPreviewModal
                        open={this.state.showParquetPreviewModal}
                        onClose={this.closeParquetPreviewModal}
                        model={model}
                        user={this.props.user}
                      />
                    }
                  </Grid.Column>
                }
              </Grid>
              {this.state.renderNodePreview &&
                <div className="nodePreviewStyle">
                  <div className="nodeStyleCancel">
                    <Icon name="cancel" style={{ fontSize: '1.5em', cursor: 'pointer' }} onClick={this.closeNodePreview} />
                  </div>
                  <NodePreview
                    onModelChange={this.props.onModelChange}
                    model={model}
                    cities={cities}
                    country={country}
                    canActivate={canActivateField}
                    handleNodePreview={this.handleNodePreview}
                    currentKey={this.state.currentClickedNode}
                    parentKeyList={this.state.listOfParentNodesKey}
                    clickedScenarioIndex={this.state.clickedScenarioIndex}
                    handleDeleteNode={this.deleteNode}
                    handleAddNode={this.addNode}
                    handleDuplicateBranch={this.duplicateBranch}
                    listRuleTypes={listRuleTypes}
                    closeModal={this.closeModal}
                    showModal={this.state.showModal.preview}
                    nodeType={this.state.nodeType}
                    openModal={this.openModal}
                    scenarioIndex={this.state.scenarioIndex}
                    addDefaultExperiment={this.addDefaultExperiment}
                    autoShowHistorySearch={this.state.autoShowHistorySearch}
                    clearAutoShowHistorySearch={this.clearAutoShowHistorySearch}
                  />
                </div>
              }
              <TridentCampaignBuilder
                onModelChange={this.props.onModelChange}
                model={model}
                cities={cities}
                country={country}
                canActivate={canActivateField}
                handleNodePreview={this.handleNodePreview}
                clickedNode={this.state.currentClickedNode}
                handleDeleteNode={this.deleteNode}
                userPermissions={userPermissions}
                listRuleTypes={listRuleTypes}
                appConfig={appConfig}
                showModal={this.state.showModal.builder}
                nodeType={this.state.nodeType}
                scenarioIndex={this.state.scenarioIndex}
                closeModal={this.closeModal}
                treatmentStartKeysList={this.state.treatmentStartKeysList}
                currentNode={this.state.currentNode}
                parentNode={this.state.parentNode}
                parentKeyList={this.state.parentKeyList}
                renderNodePreview={this.state.renderNodePreview}
                addNode={this.addNode}
                addDefaultExperiment={this.addDefaultExperiment}
              />
            </Segment>
          </div>
        </div>
      </Container>
    );
  }
}

export function mapStateToProps(state: StoreState, ownProps: object) {
  const createOrUpdate = _.get(ownProps.model, 'campaignID') ? 'update' : 'create';
  // TODO: after all users migrate to the new roles, remove the `hasPermission` check
  const hasQuestPermission = hasPermission(ownProps.userPermissions, 'challenge', '*', createOrUpdate) || hasTridentPermission(ownProps.userPermissions, '', 'quest', createOrUpdate);
  return {
    changeCampaignStatusRequest: _.get(state.requests, 'changeCampaignStatusRequest', {}),
    enableQuest: ownProps.enableQuest || hasQuestPermission,
    listRuleTypes: _.get(state, 'newTridents.listRuleTypes', {}),
    campaignObjectives: _.get(state, 'newTridents.campaignObjectives', {}),
    budgetSources: _.get(state, 'newTridents.campaignBudgetSources', {}),
    targetVerticals: _.get(state, 'newTridents.campaignTargetVerticals', {}),
    appConfig: state.app.config,
    approvalFlowConfig: _.get(state, 'newTridents.approvalFlowConfig', {}),
    featureFlagConfig: _.get(state, 'newTridents.featureFlagConfig', {}),
    cpProductsByCountry: _.get(state, 'ucd.cpProductsByCountry', {}),
    countries: _.get(state, 'countries.entities', []),
    ucdErrMessage: _.get(state, 'newTridents.ucdErrMessage', ''),
  };
}

export default connect(mapStateToProps, {
  changeCampaignStatus,
  getListRuleTypes,
  getFeatureFlagConfig,
  getCampaignBudgetSources,
  getCampaignTargetVerticals,
  getApprovalFlowConfig,
  cpListProducts,
})(TridentCampaignForm);
